import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { BrandTitle } from "../../../primitives/data-display/BrandTitle";
import { Subtitle } from "../../../primitives/data-display/Subtitle";
import { AuthSplashBackdrop } from "./AuthSplashBackdrop";
import { riseIn } from "./auth_motion";

const SplashContent = styled(Stack)({
  position: "relative",
  flex: 1,
  justifyContent: "flex-end",
});

const Rise = styled("div")<{ $delay: number }>(({ $delay }) => ({
  ...riseIn(0.9, $delay),
}));

/** The default side panel of the auth screens: wordmark and tagline over a moving backdrop. */
export function AuthSplash() {
  const { t } = useTranslation();
  return (
    <>
      <AuthSplashBackdrop />
      <SplashContent gap={2}>
        <Rise $delay={0.25}>
          <BrandTitle color="text.primary">{t("header.brand")}</BrandTitle>
        </Rise>
        <Rise $delay={0.45}>
          <Subtitle color="text.primary">{t("auth.splash.tagline")}</Subtitle>
        </Rise>
      </SplashContent>
    </>
  );
}
